import { getTeamLabelByNumber } from '@/components/pages/TraderMode/utils/utils'

const throwTournamentCancelEvents = [
  'THROW_POINT_1_POINT',
  'THROW_POINT_2_POINT',
  'THROW_POINT_3_POINT',
  'THROW_POINT_4_POINT',
  'THROW_POINT_5_POINT',
  'THROW_POINT_6_POINT',
  'THROW_POINT_7_POINT',
  'THROW_POINT_8_POINT',
  'THROW_POINT_9_POINT',
  'THROW_POINT_10_POINT',
  'THROW_POINT_1_MISS',
  'THROW_POINT_2_MISS',
  'THROW_POINT_3_MISS',
  'THROW_POINT_4_MISS',
  'THROW_POINT_5_MISS',
  'THROW_POINT_6_MISS',
  'THROW_POINT_7_MISS',
  'THROW_POINT_8_MISS',
  'THROW_POINT_9_MISS',
  'THROW_POINT_10_MISS'
]

export default {
  // 'this' - $store
  byActionType: {},
  // 'this' - $store
  byEventType: {
    'MATCH_FORMAT' (event) {
      const { extra } = event
      const {
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat: firstVersionTimerFormats,
        has_golden_set,
        inverse,
        timer_speed_up: timerSpeedUp,
        is_shootout_series_format,
        has_tackles,
        basketball_throws
      } = extra
      const timerFormat = !firstVersionTimerFormats
        ? {
          inverse,
          resetEachPeriod: true
        }
        : firstVersionTimerFormats

      this.setMatchFormat({
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat,
        timerSpeedUp,
        has_golden_set,
        has_tackles
      })

      this.setIngameProperty({
        property: 'shotoutOnly',
        value: !!basketball_throws
      })

      this.setIngameProperty({
        property: 'hasTimer',
        value: !basketball_throws
      })

      if (basketball_throws)  return

      if (is_shootout_series_format) return

      this.setShootoutSeriesFormat()
    },
    'THROW_POINT_1_MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })

      this.setScore(event)
    },
    'THROW_POINT_2_MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })

      this.setScore(event)
    },
    'THROW_POINT_3_MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })

      this.setScore(event)
    },
    'THROW_POINT_4_MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })

      this.setScore(event)
    },
    'THROW_POINT_5_MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })

      this.setScore(event)
    },
    'THROW_POINT_6_MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })

      this.setScore(event)
    },
    'THROW_POINT_7_MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })

      this.setScore(event)
    },
    'THROW_POINT_8_MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })

      this.setScore(event)
    },
    'THROW_POINT_9_MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })

      this.setScore(event)
    },
    'THROW_POINT_10_MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })

      this.setScore(event)
    },
    'THROW_POINT_1_POINT' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: true
      })

      this.setScore(event)
    },
    'THROW_POINT_2_POINT' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: true
      })

      this.setScore(event)
    },
    'THROW_POINT_3_POINT' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: true
      })

      this.setScore(event)
    },
    'THROW_POINT_4_POINT' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: true
      })

      this.setScore(event)
    },
    'THROW_POINT_5_POINT' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: true
      })

      this.setScore(event)
    },
    'THROW_POINT_6_POINT' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: true
      })

      this.setScore(event)
    },
    'THROW_POINT_7_POINT' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: true
      })

      this.setScore(event)
    },
    'THROW_POINT_8_POINT' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: true
      })

      this.setScore(event)
    },
    'THROW_POINT_9_POINT' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: true
      })

      this.setScore(event)
    },
    'THROW_POINT_10_POINT' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: true
      })

      this.setScore(event)
    },
    'CANCEL' (event) {
      const { RelatedEventNumber } = event
      const { getEventCache, getIngameData } = this
      const relatedEvent = getEventCache[RelatedEventNumber]
      const { EventCode, TeamNumber } = relatedEvent

      if (getIngameData.shotoutOnly && throwTournamentCancelEvents.includes(EventCode)) {
        this.updateShootoutStatistic({
          team: getTeamLabelByNumber(TeamNumber),
          type: 'delete'
        })
      }

      this.setScore(event)
      this.setFouls(event)
      this.setCanceled(event)
    },
    'MAIN_TIME_FINISHED' (event) {
      this.setTimer(event)
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    'ADJUST_SCORE' (event) {
      return this.$t('trader.adjust.points.title')
    }
  }
}
